import TranslatedCell from '@/components/translated-cell';
import { SELECTABLE_KEYS } from '@/components/translated-cell/translated-cell.type';
import { expectedTemplateReasonsRejected } from '@/constants/template';

export const RejectionReason = ({ reason }: { reason: string }) => (
  <TranslatedCell<SELECTABLE_KEYS>
    expectedKeys={expectedTemplateReasonsRejected}
    notationTrace="manager.sections.templates.report.reasons_rejection"
    translatedKey={reason as SELECTABLE_KEYS}
  />
);
